import { render, staticRenderFns } from "./lk-error.vue?vue&type=template&id=ca39ec46&"
import script from "./lk-error.vue?vue&type=script&lang=js&"
export * from "./lk-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-error.vue
// module id = 1383
// module chunks = 0